import sanityClient from "@sanity/client"

export default sanityClient({
    projectId: "u57809z0",
    dataset: "production"
})